import { DocumentTypeEnum } from "@finway-group/shared/lib/models"
import { Upload } from "antd"
import React from "react"

import { API_URL } from "Shared/config/consts"
import UploadFileDraggerContent, { UploadFileDraggerContentInterface } from "./UploadFileDraggerContent"

export interface UploadFileDraggerInterface extends UploadFileDraggerContentInterface {
    doFileUpload: (file: File, kind: DocumentTypeEnum) => Promise<void>
    documentType: DocumentTypeEnum
}

const { Dragger } = Upload

const UploadFileDragger: React.FC<UploadFileDraggerInterface> = ({ doFileUpload, documentType, label, isUploading, onInboxSelected }) => {
    const isMultipleUpload = documentType === DocumentTypeEnum.INVOICE || documentType === DocumentTypeEnum.OFFER

    return (
        <Dragger
            action={`${API_URL}/files`}
            headers={{ Authorization: `Bearer ${localStorage.accessToken}` }}
            multiple={isMultipleUpload}
            showUploadList={false}
            customRequest={(req) => doFileUpload(req.file, documentType)}
            accept={".jpg,.jpeg,.png,.pdf"}
            disabled={isUploading}
        >
            <UploadFileDraggerContent label={label} isUploading={isUploading} onInboxSelected={onInboxSelected} />
        </Dragger>
    )
}

export default UploadFileDragger
